export default {
    publicAccess: ['login', 'account-reset-password', 'account-update-email-confirm'],
    usertypes: {
        'admin': 1,
        'clientadmin': 2,
        'pm': 3,
        'client': 4
    },
    layertypes: {
        layer: [
            {
                id: "AC 5 DL / 70/100",
                title: "AC 5 DL / 70/100"
            },
            {
                id: "AC 8 DN / 50/70",
                title: "AC 8 DN / 50/70"
            },
            {
                id: "AC 8 DN / 70/100",
                title: "AC 8 DN / 70/100"
            },
            {
                id: "AC 8 DS / 25/55-55",
                title: "AC 8 DS / 25/55-55"
            },
            {
                id: "AC 8 DS / 50/70",
                title: "AC 8 DS / 50/70"
            },
            {
                id: "AC 11 DN / 70/100",
                title: "AC 11 DN / 70/100"
            },
            {
                id: "AC 11 DS / 25/55-55",
                title: "AC 11 DS / 25/55-55"
            },
            {
                id: "AC 11 DS / 50/70",
                title: "AC 11 DS / 50/70"
            }
        ],
        base: [
            {
                id: "AC 16 TN / 50/70",
                title: "AC 16 TN / 50/70"
            },
            {
                id: "AC 16 TN / 70/100",
                title: "AC 16 TN / 70/100"
            },
            {
                id: "AC 22 TN / 50/70",
                title: "AC 22 TN / 50/70"
            },
            {
                id: "AC 22 TN / 70/100",
                title: "AC 22 TN / 70/100"
            },
            {
                id: "AC 22 TS / 50/70",
                title: "AC 22 TS / 50/70"
            },
            {
                id: "AC 22 TS / 30/45",
                title: "AC 22 TS / 30/45"
            },
            {
                id: "AC 32 TN / 50/70",
                title: "AC 32 TN / 50/70"
            },
            {
                id: "AC 32 TN / 70/100",
                title: "AC 32 TN / 70/100"
            },
            {
                id: "AC 32 TS / 50/70",
                title: "AC 32 TS / 50/70"
            },
            {
                id: "AC 32 TS / 30/45",
                title: "AC 32 TS / 30/45"
            }
        ],
        wear: [
            {
                id: "AC 16 TD / 50/70",
                title: "AC 16 TD / 50/70"
            },
            {
                id: "AC 16 TD / 70/100",
                title: "AC 16 TD / 70/100"
            }
        ],
        binder: [
            {
                id: "AC 16 BN / 50/70",
                title: "AC 16 BN / 50/70"
            },
            {
                id: "AC 16 BS / 25/55-55",
                title: "AC 16 BS / 25/55-55"
            },
            {
                id: "AC 16 BS / 30/45",
                title: "AC 16 BS / 30/45"
            },
            {
                id: "AC 22 BS / 25/55-55",
                title: "AC 22 BS / 25/55-55"
            },
            {
                id: "AC 22 BS / 30/45",
                title: "AC 22 BS / 30/45"
            }
        ],
        mastic: [
            {
                id: "SMA 5 N / 70/100",
                title: "SMA 5 N / 70/100"
            },
            {
                id: "SMA 8 N / 50/70",
                title: "SMA 8 N / 50/70"
            },
            {
                id: "SMA 8 S / 25/55-55",
                title: "SMA 8 S / 25/55-55"
            },
            {
                id: "SMA 11 S / 25/55-55",
                title: "SMA 11 S / 25/55-55"
            }
        ]
    },
    countries: require('./data/countries_de.json'),

    /**
     * Returns the country name for the given `countryCode`. Returns `undefined`
     * if the given country code doesn’t point to a country in our list.
     *
     * @param {String} countryCode
     *
     * @returns {String | undefined}
     */
    getCountryNameByCountryCode(countryCode) {
        return this.countries[countryCode]
    },

    titles: ['Dr.', 'Prof.', 'Prof. Dr.', 'Dipl.-Inf.', 'Dipl.-Ing.'],
    active: [1, 0],
    statuses: ['open', 'busy', 'finished', 'cancelled', 'notcancelled'],
    placementTypes: ['street', 'sidewalk'],
    dateFormat: 'dd.MM.yyyy',
    disabledDates: {
        days: [6, 0],
    },
    uploads: ['jpg', 'jpeg', 'png', 'pdf'],
    formatNumber: function (value) {
        // help from https://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formateCurrency: function (value) {
        return new Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR'}).format(value);
    },
    limitString: function (value, length, suffix) {
        if (value.length > length) {
            return value.substring(0, length) + suffix;
        }
        return value;
    },
    /**
     * Push a query only when it differs from the current one.
     * Vue Router rejects a push to the current location with NavigationDuplicated.
     */
    pushQuery: function (router, currentQuery, nextQuery) {
        let nextKeys = Object.keys(nextQuery);
        let currentKeys = Object.keys(currentQuery);
        let sameLocation = nextKeys.length === currentKeys.length && nextKeys.every(function (key) {
            return String(nextQuery[key]) === String(currentQuery[key]);
        });

        if (sameLocation) {
            return Promise.resolve();
        }

        return router.push({ query: nextQuery }).catch(function (error) {
            if (error.name !== "NavigationDuplicated") {
                throw error;
            }
        });
    },
    logger: function () {
        try {
            console.log.apply(console, arguments);
        } catch (e) {
            try {
                opera.postError.apply(opera, arguments);
            }
            catch (e) {
                alert(Array.prototype.join.call(arguments, " "));
            }
        }
    },
    history: null
};
